import { HttpService } from './base/http.service';

export interface Province {
  id: number;
  id_istat: number;
  code: string;
  name: string;
  country: string;
}

interface ProvincesResponse {
  success: boolean;
  data: Province[];
}

class ProvincesService extends HttpService {
  private cachedProvinces: Province[] | null = null;

  async getAll(): Promise<Province[]> {
    // Cache per evitare chiamate multiple
    if (this.cachedProvinces) {
      return this.cachedProvinces;
    }

    const response = await this.get<ProvincesResponse>('socialapp/provinces');
    this.cachedProvinces = response.data;
    return this.cachedProvinces;
  }
}

export const provincesService = new ProvincesService();
